export default class NoPaymentMethod extends Error {

}
